import gql from "graphql-tag";

export const fetchClaimsGql = gql`
  query FetchClaims {
    claims
  }
`;
